'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _webSso = require('@vezeeta/web-sso');

var _confirmations = require('../actions/confirmations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchConfirmations),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(saveConfirmations),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(confirmationsSaga);

function fetchConfirmations(action) {
  var apiWrapper, response;
  return _regenerator2.default.wrap(function fetchConfirmations$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new _webSso.AuthApi();

        case 2:
          apiWrapper = _context.sent;
          _context.next = 5;
          return apiWrapper.post(_webUtils.Urls.getConfirmationsUrl, action.keys);

        case 5:
          response = _context.sent;
          _context.next = 8;
          return (0, _effects.put)({
            type: _confirmations.CONFIRMATIONS.FETCH_SUCCESS,
            confirmations: response.data
          });

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saveConfirmations(action) {
  var apiWrapper, changesDoctorsInfoList, response;
  return _regenerator2.default.wrap(function saveConfirmations$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return new _webSso.AuthApi();

        case 2:
          apiWrapper = _context2.sent;
          changesDoctorsInfoList = [];

          if (action.confirmations && action.confirmations.length) {
            action.confirmations.forEach(function (item) {
              if (item.isChanged) {
                var isChanged = item.isChanged,
                    restOfObj = _objectWithoutProperties(item, ['isChanged']);

                changesDoctorsInfoList.push(restOfObj);
              }
            });
          }
          _context2.next = 7;
          return apiWrapper.post(_webUtils.Urls.saveConfirmationsUrl, {
            ActionMaker: 'Doctor',
            AccountRoomActions: changesDoctorsInfoList
          });

        case 7:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 13;
            break;
          }

          _context2.next = 11;
          return (0, _effects.put)({
            type: _confirmations.CONFIRMATIONS.SAVE_SUCCESS,
            confirmations: action.confirmations
          });

        case 11:
          _context2.next = 15;
          break;

        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _confirmations.CONFIRMATIONS.SAVE_FAIL
          });

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function confirmationsSaga() {
  return _regenerator2.default.wrap(function confirmationsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_confirmations.CONFIRMATIONS.FETCH, fetchConfirmations);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_confirmations.CONFIRMATIONS.SAVE, saveConfirmations);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = confirmationsSaga;
module.exports = exports['default'];